import ImportExportIcon from '@mui/icons-material/ImportExport';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface CSVImportExportButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function CSVImportExportButton({ onClick, disabled }: CSVImportExportButtonProps) {
  return (
    <SmallButton
      color="brandV2Black"
      disabled={disabled}
      onClick={onClick}
      startIcon={<ImportExportIcon />}
      variant="outlined"
      // brandV2Black is a fixed navy (invisible on a dark surface); drive the
      // outlined label + border from flipping tokens so it reads in both modes.
      sx={{ color: 'text.primary', borderColor: 'divider' }}
    >
      {t('csv_import_export.button')}
    </SmallButton>
  );
}
